(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Recently-Viewed-Products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('.rand-swiper', {
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: '.rand-button-next',
        prevEl: '.rand-button-prev',
      },
      breakpoints: {
        360:  { slidesPerView: 2 },
        480:  { slidesPerView: 2 },
        640:  { slidesPerView: 2 },
        768:  { slidesPerView: 2.5 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["games-puzzles-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('.swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        400: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison7-faq"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = null;
    if(document.currentScript){ root = document.currentScript.closest('.m7f-faq'); }
    if(!root){ root = document.querySelector('.m7f-faq'); }
    if(!root) return;

    // Accordion
    root.querySelectorAll('.m7f-item').forEach(function(item){
      var q = item.querySelector('.m7f-q');
      var a = item.querySelector('.m7f-a');
      q.addEventListener('click', function(){
        var isOpen = item.classList.contains('open');
        item.closest('.m7f-cat-group').querySelectorAll('.m7f-item.open').forEach(function(other){
          if(other !== item){
            other.classList.remove('open');
            other.querySelector('.m7f-a').style.maxHeight = null;
          }
        });
        if(isOpen){
          item.classList.remove('open');
          a.style.maxHeight = null;
        } else {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });

    // Category filter
    var catBtns = root.querySelectorAll('.m7f-cat-btn');
    var groups = root.querySelectorAll('.m7f-cat-group');

    catBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        catBtns.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var cat = btn.dataset.cat;
        groups.forEach(function(g){
          var show = (cat === 'all' || g.dataset.cat === cat);
          g.dataset.hidden = show ? 'false' : 'true';
          g.style.display = show ? '' : 'none';
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison7-sticky-addtocart"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var bar = document.getElementById('m7StickyBar');
    if(!bar) return;

    // Locate the real add-to-cart form. Tries the most specific match first,
    // then falls back to the first cart form on the page that isn't inside
    // a recommendation/carousel block.
    function findProductForm(){
      var scoped = document.querySelector('[id^="ProductInformation-"] form[action*="/cart/add"], [id^="MainProduct-"] form[action*="/cart/add"], product-form form[action*="/cart/add"]');
      if(scoped) return scoped;
      var all = document.querySelectorAll('form[action*="/cart/add"]');
      for(var i=0; i<all.length; i++){
        if(!all[i].closest('[id*="recommend"], [id*="carousel"], [id*="Recently"]')) return all[i];
      }
      return all[0] || null;
    }

    var form = findProductForm();
    if(!form) return; // nothing to mirror — bar stays hidden

    var realBtn = form.querySelector('button[type="submit"], button[name="add"], [type="submit"]');
    var watchTarget = form;

    // Show the sticky bar once the real add-to-cart control has been scrolled
    // past (not before it's been reached, and not while it's still visible).
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      });
    }, { threshold: 0 });
    io.observe(watchTarget);

    // Mirror live price if the theme updates it on variant change.
    var priceEl = document.querySelector('[id^="ProductInformation-"] .price, [id^="MainProduct-"] .price, .product__price, .price');
    var stickyPrice = document.getElementById('m7StickyPrice');
    if(priceEl && stickyPrice){
      var mo = new MutationObserver(function(){ stickyPrice.textContent = priceEl.textContent.trim(); });
      mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }

    // Max available quantity — from the section's data attribute (computed
    // server-side from real inventory), used to cap the stepper and warn
    // only when the customer actually tries to go over it.
    var maxQtyAttr = bar.dataset.maxQty;
    var maxQty = maxQtyAttr !== undefined ? parseInt(maxQtyAttr, 10) : null;
    var stockWarning = document.getElementById('m7StickyStockWarning');
    var stockPrefix = bar.dataset.stockPrefix || 'Only';
    var stockSuffix = bar.dataset.stockSuffix || 'available';

    function showStockWarning(){
      if(!stockWarning || maxQty === null) return;
      stockWarning.textContent = stockPrefix + ' ' + maxQty + ' ' + stockSuffix;
      stockWarning.hidden = false;
    }
    function hideStockWarning(){
      if(!stockWarning) return;
      stockWarning.hidden = true;
    }

    // Quantity stepper — syncs with the theme's real quantity input if one
    // exists, so the quantity carries over correctly when Add is clicked.
    var realQtyInput = form.querySelector('input[name="quantity"]');
    var qtyVal = document.getElementById('m7StickyQtyVal');
    var qtyMinus = document.getElementById('m7StickyQtyMinus');
    var qtyPlus = document.getElementById('m7StickyQtyPlus');
    var qty = realQtyInput ? (parseInt(realQtyInput.value, 10) || 1) : 1;
    qtyVal.textContent = qty;

    function setQty(newQty){
      qty = Math.max(1, newQty);
      qtyVal.textContent = qty;
      if(realQtyInput){
        realQtyInput.value = qty;
        realQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        realQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
    qtyMinus.addEventListener('click', function(){
      setQty(qty - 1);
      if(maxQty === null || qty < maxQty) hideStockWarning();
    });
    qtyPlus.addEventListener('click', function(){
      if(maxQty !== null && qty >= maxQty){
        showStockWarning(); // already at the cap — don't increment further
        return;
      }
      setQty(qty + 1);
      if(maxQty !== null && qty >= maxQty) showStockWarning();
    });

    // Keep sticky quantity in sync if the real quantity input changes elsewhere on the page.
    if(realQtyInput){
      realQtyInput.addEventListener('change', function(){
        var v = parseInt(realQtyInput.value, 10) || 1;
        qty = v;
        qtyVal.textContent = qty;
        if(maxQty !== null && qty >= maxQty){ showStockWarning(); } else { hideStockWarning(); }
      });
    }

    // Proxy-click the real button so all existing add-to-cart behavior
    // (AJAX, cart drawer, loading state, sold-out handling) is reused as-is.
    var stickyBtn = document.getElementById('m7StickyAddBtn');
    stickyBtn.addEventListener('click', function(){
      if(!realBtn) return;
      if(realBtn.disabled){ stickyBtn.disabled = true; stickyBtn.textContent = 'Sold Out'; return; }
      if(realQtyInput){ realQtyInput.value = qty; }
      realBtn.click();
    });

    // Reflect disabled/sold-out state on the sticky button too.
    if(realBtn){
      var syncDisabled = function(){ stickyBtn.disabled = realBtn.disabled; };
      syncDisabled();
      var btnObserver = new MutationObserver(syncDisabled);
      btnObserver.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('.related-swiper', {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.related-button-next',
        prevEl: '.related-button-prev',
      },
      breakpoints: {
        480: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["this-weeks-edit"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('.swiper', {
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        400: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 }
      }
    });
  }
});



  } catch(e) { console.error(e); }
})();
})();
